import React from 'react';
import { Wallet2 } from './icons/Icons';

const Header = () => {
  return (
    <header>
      <div className='logo'>
        <span>
          <Wallet2 />
        </span>
      </div>
    </header>
  );
};

export default Header;
